export enum StepsSize {
  Small = 'small',
  Default = 'default'
}